
export const themeServices = (theme: string, currentClasses: string[]): void => {
    currentClasses.push(`${currentClasses[0]}_theme_${theme}`)
}
